/**
 * Broker comp-plan client (DEV-3636, Skynet.Accounts behind the accounts gateway).
 * GET /api/sub-companies/me/comp-plan returns the latest active compensation plan
 * for the caller's own sub-company (the server scopes to the authenticated caller,
 * so there is no companyId path param). 204 when none.
 *
 * Read-only on the homepage: compensation type + basis points + effective date +
 * next change window + period + status. No projected $/loan anywhere.
 *
 * Response shape (200):
 *   { compensationType, basisPoints, effectiveDate, nextChangeWindow, periodType,
 *     status }
 */
export class BrokerCompPlanApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompPlan({ config = {} } = {}) {
    return this.#http.get('/api/command-center/me/comp-plan', config);
  }
}
